import React, { useEffect, useState } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useI18n } from "../../i18n/useI18n";
import { PropTypes } from "prop-types";
import "./style.less";

const [HbrSpinner] = reactWrapper(["hbr-spinner"]);

const OverLappingSpinner = ({ extraDetailsTxt }) => {
  const { tCommon, tViews } = useI18n('common');
  const loading = tViews('loading');
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    setAnnouncement("");
    const timer = setTimeout(() => setAnnouncement(loading), 100);
    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <div
      className="overlapping-spinner flex-column-full width-full"
      aria-busy="true"
    >
      <HbrSpinner
        className="flex-column-full flex-items-center width-full"
        direction="column"
        size="large"
      >
        <div slot="label" data-testid="loading-text">{tCommon('loaderText')}</div>
        {extraDetailsTxt && <div slot="label">{extraDetailsTxt}</div>}
      </HbrSpinner>
      <span
        className="spinner-live-region"
        aria-live="polite"
        aria-atomic="true"
        role="status"
      >
        {announcement}
      </span>
    </div>
  );
};

OverLappingSpinner.propTypes = {
  extraDetailsTxt: PropTypes.string
}

export default OverLappingSpinner;
